import { render } from "./RecoveryPasswordButton.vue?vue&type=template&id=0b3aa21e&ts=true"
import script from "./RecoveryPasswordButton.vue?vue&type=script&lang=ts"
export * from "./RecoveryPasswordButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/UserInfo/RecoveryPasswordButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b3aa21e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b3aa21e', __exports__)) {
    api.reload('0b3aa21e', __exports__)
  }
  
  module.hot.accept("./RecoveryPasswordButton.vue?vue&type=template&id=0b3aa21e&ts=true", () => {
    api.rerender('0b3aa21e', render)
  })

}


export default __exports__